module.exports = __webpack_public_path__ + "img/LifeIllustrated.45f66ef9.webp";